//
import Index from '@/views/Index.vue'
import { MainLayout } from '@/components/reusable_components/next'

//
import AccountingMenu from './Accounting'
import HumanResourceRoutes from './HumanResource'
import PosRoutes from './POS'
import PurchaseRoutes from './Purchase'
import SaleRoutes from './Sale'

//
export default [
    {
        path: '/',
        component: MainLayout,
        props: {
            breadcrumbsProps: {
                indexText: 'Finanzas',
            },
        },
        children: [
            //
            {
                path: '',
                name: 'index',
                component: Index,
            },

            //
            ...AccountingMenu,
            ...HumanResourceRoutes,
            ...PosRoutes,
            ...PurchaseRoutes,
            ...SaleRoutes,
        ],
    },
]
